import BooksSearchService from './books-search-service';
import URLS from '@d-shared/urls/urls';

export default new BooksSearchService(URLS.api.books);
